import { render } from "./Transactions.vue?vue&type=template&id=2dc353e7&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"

import "./Transactions.vue?vue&type=style&index=0&id=2dc353e7&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc353e7"]])

export default __exports__